<template>
  <div class="cruise_item">
    <nuxt-link :to="`/company/cruise/${cruiseItem.id}`" target="_blank">
      <el-image :src="cruiseItem.cover" fit="cover" class="w-full h-[133px] rounded-t" />
    </nuxt-link>
    <el-image :src="cruiseItem.logo" class="w-[80px] h-[22px] absolute top-2 left-2 z-20 bg-white" />
    <div class="px-[15px] relative h-[80px]">
      <h3 class="en_name text-lg text-dark font-medium">{{ cruiseItem.name }}</h3>
      <p class="en_name text-[#606060]">{{ cruiseItem.en_name }}</p>
      <div class="flex w-[198px] absolute bottom-0 justify-between">
        <div v-for="btn in buttonList" :key="btn.name">
          <nuxt-link :to="btn.router_path" replace target="_blank">
            <p class="btn">{{ btn.name }}</p>
          </nuxt-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FrontPcCuriousListItem',
  props: {
    cruiseItem: Object,
  },

  data() {
    return {
      buttonList: [
        {
          name: '产品',
          router_path: `/product/automation/foreign-cruise-search?cruise=${this.cruiseItem.id}&brand=${this.cruiseItem.company_id}`
        },
        {
          name: '图片',
          router_path: `/company/cruise/gallery?cruiseid=${this.cruiseItem.id}`,
        },
        {
          name: '配置',
          router_path: `/company/cruise/${this.cruiseItem.id}`,
        },
        {
          name: '定位',
          router_path: `/cruise-map/?keyword=${this.cruiseItem.name}`
        },
      ]
    };
  },
  mounted() {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.cruise_item {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  height: 233px;
  margin-right: 15px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  position: relative;
  width: 228px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
}
.cruise_item .en_name {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.cruise_item .btn {
  border-radius: 0.125rem;
  margin-top: 10px;
  padding-left: 8px;
  padding-right: 8px;
  --tw-text-opacity: 1;
  color: rgba(31, 33, 41, var(--tw-text-opacity));
  font-size: 13px;
  border: 1px solid #D4D7DE;
}
.cruise_item .btn:hover, .cruise_item .btn.active {
  color: $color-primary;
  border: 1px solid $color-primary;
}
</style>
